import React from 'react';
import { AlertTriangle } from 'lucide-react';

/** Confirm dialog shown before a save that moves budget to or from CCC / CC-12 */
const BudgetMoveConfirm = ({ title, children, confirmLabel = 'Yes, continue', onConfirm, onCancel }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
        <div role="dialog" aria-modal="true" className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md">
            <div className="p-5 border-b border-gray-200 dark:border-gray-700 flex items-center gap-2">
                <AlertTriangle className="h-4 w-4 text-amber-500 flex-shrink-0" />
                <h3 className="text-sm font-bold text-gray-900 dark:text-white">{title}</h3>
            </div>
            <div className="p-5 space-y-3 text-sm text-gray-700 dark:text-gray-300">{children}</div>
            <div className="p-4 flex justify-end gap-2 border-t border-gray-200 dark:border-gray-700">
                <button onClick={onCancel} className="px-4 py-1.5 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 rounded-lg text-xs font-semibold">Cancel</button>
                <button onClick={onConfirm} className="px-4 py-1.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-xs font-semibold">{confirmLabel}</button>
            </div>
        </div>
    </div>
);

/** Amber "keep this much in the Budget Balance" note used inside the dialogs and on the amendment pages */
export const KeepBalanceNote = ({ budgetCC, amount, failsWhen = 'the change fails', then = 'change the value' }) => (
    <p className="p-3 rounded-xl bg-amber-50 dark:bg-amber-900/10 border border-amber-200 dark:border-amber-800/60 text-amber-800 dark:text-amber-300 text-xs">
        Keep at least <span className="font-bold">{amount}</span> in the {budgetCC} Budget Balance for this financial year.
        If the balance is lower, {failsWhen} with an insufficient budget balance message. Add the required budget to {budgetCC} first, then {then}.
    </p>
);

export default BudgetMoveConfirm;
